import React, { useState, useEffect } from "react";
import { Card, Table, Checkbox } from "antd";
import CardTitleFilter from "../../components/objects/CardTitle";
import GainIcon from "../../components/gainicon";
import GainSelect from "../../components/objects/GainSelect";
import GainButton from "../../components/objects/GainButton";

import { pollutants } from "./data/options";
import { getScenarioStructure, getScenarios } from "../../services/api";
import { Search, Sort } from "../../tools";

export default function Index(props) {
  const [data, setData] = useState([]);
  const [TableData, setTableData] = useState([]);
  const [TableColumn, setTableColumn] = useState([]);
  const [LoadingTable, setLoadingTable] = useState(false);
  const [Technology, setTechnology] = useState({
    options: [
      {
        name: "All Technology",
        value: "All Technology",
      },
    ],
    value: "All Technology",
  });
  const [Scenario, setScenario] = useState({
    options: [],
    value: false,
  });
  const [Pollutant, setPollutant] = useState({
    options: pollutants,
    value: "All Pollutants",
  });

  const [Activity, setActivity] = useState(["MD", "GSL", "LPG", "GAS"]);
  const [Sector, setSector] = useState([
    "TRA_RD_M4",
    "TRA_RD_LD4C",
    "TRA_RD_LD4T",
    "TRA_RD_HDT",
    "TRA_RD_HDB",
  ]);

  useEffect(() => {
    scenarioLists();
  }, []);

  const scenarioLists = async () => {
    const res = await getScenarios();
    const scenario = res.data.map((item) => {
      return {
        name: item.scenario_name,
        value: item.file_name,
      };
    });
    setScenario({ ...Scenario, options: scenario, value: scenario[0].value });
    dataLists(res.data[0].file_name);
  };

  const handleShow = () => {
    dataLists(Scenario.value);
    console.log({ Sector, Activity });
  };

  const dataLists = async (file) => {
    setLoadingTable(true);
    const payload = {
      file,
      sheet: "5. EF",
    };
    const res = await getScenarioStructure(payload);
    if (res.status === 200) {
      const { headers, values } = res.data.data;
      setLoadingTable(false);

      const filter = values.filter((item) => {
        if (Technology.value !== "All Technology") {
          return (
            item.Technology === Technology.value &&
            Sector.includes(item.Sector) &&
            Activity.includes(item.Activity)
          );
        } else {
          return (
            Sector.includes(item.Sector) && Activity.includes(item.Activity)
          );
        }
      });

      setData(filter);
      setTableData(filter);

      const technology = values
        .map((val) => val.Technology)
        .filter((item, pos, self) => {
          return self.indexOf(item) == pos;
        })
        .map((val) => {
          return {
            name: val,
            value: val,
          };
        });

      setTechnology({
        ...Technology,
        options: [...Technology.options, ...technology],
      });

      const filterHeader = headers.filter((item) => {
        if (Pollutant.value !== "All Pollutants") {
          return (
            item == "Activity" ||
            item == "Sector" ||
            item == "Technology" ||
            item == Pollutant.value
          );
        }
        return item;
      });

      setTableColumn(
        filterHeader.map((column) => ({
          title: column,
          dataIndex: column,
          key: column,
        }))
      );
    }
  };

  return (
    <div>
      {!props.embed && <h1 className="text-3xl font-bold">Emission</h1>}
      <div className="grid grid-cols-3 2xl:grid-cols-4 gap-6 pt-8">
        <Card
          title={
            <CardTitleFilter
              filterOptions={TableColumn}
              add={false}
              onSearch={(keyword) => {
                const dataSearch = Search(data, keyword);
                setTableData(dataSearch);
              }}
              onSort={(dataIndex) => {
                const dataSort = Sort(data, dataIndex);
                setTableData(dataSort);
              }}
            />
          }
          className="border-none rounded-lg rounded-b-none col-span-2 2xl:col-span-3"
        >
          <Table
            dataSource={TableData}
            columns={TableColumn}
            scroll={{ x: "auto" }}
            className="font-light"
            loading={LoadingTable}
          />
        </Card>
        <Card className="border-none rounded-lg px-6 py-3">
          <div className="flex justify-between items-baseline pb-3">
            <h1 className="font-bold text-base"></h1>
            <div>
              <GainIcon name="refresh" />
            </div>
          </div>
          <GainSelect
            label={<span className="font-bold">Emission scenario</span>}
            options={Scenario.options}
            value={Scenario.value}
            onChange={(e) => setScenario({ ...Scenario, value: e })}
          />
          <br />
          <GainSelect
            label={<span className="font-bold">Technology type</span>}
            options={Technology.options}
            value={Technology.value}
            onChange={(e) => setTechnology({ ...Technology, value: e })}
          />
          <br />
          <GainSelect
            label={<span className="font-bold">Polltants</span>}
            options={Pollutant.options}
            default={Pollutant.value}
            onChange={(e) => setPollutant({ ...Pollutant, value: e })}
          />
          <div>
            <h1 className="font-bold text-base pt-6">Activity</h1>
            <Checkbox.Group
              style={{ width: "100%" }}
              name="activity"
              onChange={setActivity}
              value={Activity}
            >
              <div className="grid grid-cols-2">
                <Checkbox value="GAS">GAS</Checkbox>
                <Checkbox value="GSL">GSL</Checkbox>
                <Checkbox value="LPG">LPG</Checkbox>
                <Checkbox value="MD">MD</Checkbox>
              </div>
            </Checkbox.Group>
          </div>
          <div>
            <h1 className="font-bold text-base pt-6">Sector</h1>
            <Checkbox.Group
              style={{ width: "100%" }}
              onChange={setSector}
              value={Sector}
            >
              <div className="grid grid-cols-1">
                <Checkbox value="TRA_RD_HDB">TRA_RD_HDB</Checkbox>
                <Checkbox value="TRA_RD_HDT">TRA_RD_HDT</Checkbox>
                <Checkbox value="TRA_RD_LD4C">TRA_RD_LD4C</Checkbox>
                <Checkbox value="TRA_RD_LD4T">TRA_RD_LD4T</Checkbox>
                <Checkbox value="TRA_RD_M4">TRA_RD_M4</Checkbox>
              </div>
            </Checkbox.Group>
          </div>
          <div className="pt-12 w-full pb-4" onClick={handleShow}>
            <GainButton label="Show" center />
          </div>
        </Card>
      </div>
    </div>
  );
}
